import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';

/////////////////////////////////////////////////////////////////////////////
////// Clases COMUNES a cultivos, almacenes y empresas deshidratadoras //////
/////////////////////////////////////////////////////////////////////////////
export class RecintoPIAViewModel {
    public Id: number;
    public IdSolicitudCam: number;
    public IdUsuario?: number;
    public FechaCreacion?: Date;
}

export class FilterRecintosSolicitudCamViewModel extends FilterSearchingBaseViewModel {
    public Id: number; // Id. de la solicitud.
}

///////////////////////////////////////////////////////////////////
////// RECINTOS PARCELAS O INVERNADEROS ///////////////////////////
///////////////////////////////////////////////////////////////////
export class TwCultivoSolicitudCam {
    public IdCultivo: number;
    public IdSolicitudCam: number;
    public IdUsuario?: number;
    public FechaCreacion?: Date | null;
}

export class TwCultivoSolicitudCamViewModel extends TwCultivoSolicitudCam {
    public MarkToDelete?: number;
}

export class CultivosSolicitudCamViewModel {
    public IdCA: number;
    public IdPeriodoCam: number;
    public cultivosSolicitudCam: TwCultivoSolicitudCamViewModel[];
}

////////////////////////////////////////////////////////////////////
////// ALMACENES / CÓDIGOS DE CONFECCIÓN ///////////////////////////
////////////////////////////////////////////////////////////////////

export class TwAlmacenSolicitudCam {
    public IdAlmacen: number;
    public IdSolicitudCam: number;
    public IdUsuario?: number;
    public FechaCreacion?: Date;
}

export class TwAlmacenesSolicitudCamViewModel extends TwAlmacenSolicitudCam {
    public MarkToDelete?: number;
}

export class AlmacenesSolicitudViewModel {
    public IdCA: number;
    public IdPeriodoCam: number;
    public almacenesSolicitudCam: TwAlmacenesSolicitudCamViewModel[];
}
////////////////////////////////////////////////////////////////////
////// EMPRESAS DESHIDRATADORAS ////////////////////////////////////
////////////////////////////////////////////////////////////////////
export class TwEmpresaDeshidratadoraSolicitudCam {
    public IdEmpresaDeshidratadora: number;
    public IdSolicitudCam: number;
    public IdUsuario?: number;
    public FechaCreacion?: Date;
}
export class TwEmpresasSolicitudCamViewModel extends TwEmpresaDeshidratadoraSolicitudCam {
    public MarkToDelete?: number;
}
export class EmpresasDeshidratadorasSolicitudViewModel {
    public IdCA: number;
    public IdPeriodoCam: number;
    public empresasSolicitudCam: TwEmpresasSolicitudCamViewModel[];
}
